import { Button, FormControl } from '@material-ui/core';
import styled from 'styled-components';

interface Iprops {
  identificationKeyError?: boolean;
  ownershipTypeError?: boolean;
}

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;

  & .MuiButton-label {
    color: #fff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #292828;

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: ${props => props.theme.colors.primaryText};
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 20px 0;
      }
    }

    .TextField-lgpd {
      width: 100%;
      max-width: 300px;

      & + .TextField-lgpd {
        margin-top: 0px;
      }
    }
  }

  .main-content-assuntos {
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;
    border-bottom: 1px #707070 solid;

    button {
      margin-left: auto;
      margin-top: 20px;
    }
  }

  .lista-assuntos {
    margin-top: 10px;

    .table-lgpd {
      .MuiToolbar-root {
        color: #fff;
      }

      .MuiTablePagination-selectRoot {
        display: none;
      }

      .MuiPaper-root {
        background-color: ${props => props.theme.colors.primaryBackground};
        border: 1px solid #707070;

        .MuiTableHead-root {
          .MuiButtonBase-root {
            font-size: 1.4rem;
            color: ${props => props.theme.colors.primaryText};
          }

          .MuiSvgIcon-root {
            color: ${props => props.theme.colors.primaryText} !important;
          }
        }

        .MuiTableBody-root {
          .MuiTableCell-root {
            font-size: 1.2rem;
          }

          .MuiTableCell-body {
            color: ${props => props.theme.colors.primaryText};
          }

          .Mui-selected {
            background-color: rgba(0, 69, 245, 0.08);
          }

          .MuiCheckbox-root {
            color: ${props => props.theme.colors.primaryText};
          }

          .Mui-checked {
            color: #136edb !important;
          }

          .MuiButtonBase-root {
            &:hover {
              background-color: rgba(0, 69, 245, 0.08);
            }
          }
        }
      }
    }
  }

  h1 {
    font-size: 24px;
    color: #fff;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 18px;
    color: #fff;
    margin-bottom: 20px;
  }

  .assuntos {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .contact-dpo-right {
    flex: 1;
    padding: 0 25px;
  }

  .TextField-lgpd {
    width: 100%;
    max-width: 300px;

    & + .TextField-lgpd {
      margin-left: 30px;
    }

    > label {
      color: ${props => props.theme.colors.primaryText};
      font-size: 1.4rem;
    }

    .MuiInputBase-root {
      font-size: 1.4rem;

      input {
        color: ${props => props.theme.colors.primaryText};
        font-size: 1.4rem;
      }
      fieldset {
        border-color: #929292;
      }
    }
  }

  .descricao-solicitacao {
    color: ${props => props.theme.colors.primaryText};
    font-size: 14px;
    margin: 7px 0 4px;
  }

  .message-DPO {
    border-radius: 4px;
    width: 100%;
    background: ${props => props.theme.colors.primaryBackground};
    color: ${props => props.theme.colors.primaryText};
    padding: 10px 20px;
  }
`;

export const FormControlLGPD = styled(FormControl)<Iprops>`
  width: 100%;
  max-width: 300px;
  margin-left: 50px !important;

  .MuiInputBase-root {
    color: ${props => props.theme.colors.primaryText};

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030' : props.theme.colors.primaryText};
    }

    svg {
      top: 20px;
      color: ${props =>
        props.ownershipTypeError
          ? '#c53030 !important'
          : props.theme.colors.primaryText};
    }
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.ownershipTypeError
          ? '#c53030 !important'
          : props.theme.colors.primaryText};

      &:hover fieldset {
        border-color: ${props =>
          props.ownershipTypeError
            ? '#c53030'
            : props.theme.colors.primaryText};
      }

      legend {
        border-bottom: 0;
        width: auto !important;
      }
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030 !important' : '#1535ff !important'};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.identificationKeyError
        ? '#c53030 !important'
        : '#1535ff !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props =>
      props.identificationKeyError
        ? '#c53030'
        : props.theme.colors.primaryText};
  }

  padding: 2px 10px;
  margin-left: -5px;

  .MuiSelect-select:not([multiple]) option,
  .MuiSelect-select:not([multiple]) optgroup {
    color: #222;
  }
`;

export const SearchButton = styled(Button)`
  && {
    background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
    padding: 7px 14px;
    border-radius: 4px;
    height: 53px;
    width: 180px;
    margin-left: 50px;

    & .MuiButton-label {
      color: #fff;
      font-size: 1.2rem;
    }
  }
`;
